const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp + (timestamp?.includes?.('Z') ? '' : 'Z'));
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });
};

export default formatTimestamp;
